import { Slot } from 'expo-router';

export default function OnboardingLayout() {
  // Use the parent navigator (RootLayout Stack) to avoid nested navigator issues on Android.
  return <Slot />;
}


